module.exports = __webpack_public_path__ + "assets/logos/made-by-rt-mark-black.svg";